import React from 'react';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

export default function IndexActivitiesSkeleton() {
  return (
    <div>
      <div className="tw-relative tw-flex tw-items-center tw-gap-9 max-nine:tw-w-full max-nine:tw-justify-between">
        <div className="tw-w-[135px] max-nine:tw-w-[105px]">
          <Skeleton height={30} />
        </div>
        <div className="tw-w-[100px] max-nine:tw-w-[90px]">
          <Skeleton height={30} />
        </div>
        {/* Indicator line that mimics the active tab indicator */}
        <div className="tw-absolute -tw-bottom-2 tw-z-10 tw-h-[4px] tw-w-[135px] tw-bg-gray-200"></div>
        <div className="tw-absolute -tw-bottom-2 tw-h-[2px] tw-w-full tw-bg-gray-100 max-nine:tw-hidden"></div>
      </div>

      {/* Content wrapper with proper spacing */}
      <div className="tw-relative tw-pb-[10px]">
        {/* Tables wrapper */}
        <div className="tw-absolute tw-inset-0 nine:tw-flex nine:tw-items-start nine:tw-justify-between nine:tw-gap-8 nine:child:tw-basis-2/4">
          <div className="max-nine:tw-w-full">
            <div className="max-nine:tw-relative max-nine:tw-max-h-[580px] max-nine:tw-overflow-hidden">
              {/* Gradient overlay for mobile */}
              <div className="tw-absolute tw-bottom-0 tw-left-0 tw-flex tw-h-2/3 tw-w-full tw-items-end tw-justify-center tw-bg-gradient-to-t tw-from-white/95 tw-via-gray-50 tw-to-transparent nine:tw-hidden">
                <div className="tw-relative tw-top-24 tw-mb-44 tw-h-8 tw-w-24">
                  <Skeleton height={32} />
                </div>
              </div>

              {/* Table skeleton */}
              <table className="tw-table tw-w-full tw-border-separate tw-border-spacing-y-2">
                <thead className="tw-overflow-hidden nine:tw-h-[64px]">
                  <tr className="tw-relative child:tw-py-2">
                    <th className="tw-w-[5%] max-nine:tw-hidden">
                      <Skeleton height={20} />
                    </th>
                    <th className="tw-w-[15%] max-nine:tw-hidden">
                      <Skeleton height={20} />
                    </th>
                    <th className="tw-w-[50%] max-nine:tw-w-[90%]">
                      <Skeleton height={20} />
                    </th>
                    <th className="tw-w-[15%] max-nine:tw-hidden">
                      <Skeleton height={20} />
                    </th>
                    <th className="max-nine:tw-w-[10%]">
                      <div className="max-nine:tw-flex max-nine:tw-justify-end">
                        <Skeleton height={20} width={80} />
                      </div>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {[...Array(5)].map((_, index) => (
                    <tr key={index} className="tw-pb-2 nine:tw-h-[71px]">
                      <td className="tw-w-[5%] max-nine:tw-hidden">
                        <Skeleton height={25} />
                      </td>
                      <td className="tw-w-[15%] max-nine:tw-hidden">
                        <Skeleton height={50} width={50} />
                      </td>
                      <td className="tw-w-[50%]">
                        <div className="tw-flex tw-w-full tw-items-center tw-gap-3">
                          <div className="nine:tw-hidden">
                            <Skeleton height={50} width={50} />
                          </div>
                          <Skeleton className="tw-flex-1" height={25} />
                        </div>
                      </td>
                      <td className="tw-w-[15%] max-nine:tw-hidden">
                        <Skeleton height={25} width={60} />
                      </td>
                      <td className="tw-w-fit tw-whitespace-nowrap">
                        <div className="tw-flex tw-justify-end">
                          <Skeleton height={25} width={30} />
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>

          {/* Second table for desktop only */}
          <div className="max-nine:tw-hidden">
            <table className="tw-table tw-w-full tw-border-separate tw-border-spacing-y-2">
              <thead className="tw-overflow-hidden nine:tw-h-[64px]">
                <tr className="tw-relative child:tw-py-2">
                  <th className="tw-w-[5%]">
                    <Skeleton height={20} />
                  </th>
                  <th className="tw-w-[15%]">
                    <Skeleton height={20} />
                  </th>
                  <th className="tw-w-[50%]">
                    <Skeleton height={20} />
                  </th>
                  <th className="tw-w-[15%]">
                    <Skeleton height={20} />
                  </th>
                  <th className="tw-w-fit">
                    <div className="tw-flex tw-justify-end">
                      <Skeleton height={20} width={80} />
                    </div>
                  </th>
                </tr>
              </thead>
              <tbody>
                {[...Array(5)].map((_, index) => (
                  <tr key={index} className="tw-pb-2 nine:tw-h-[71px]">
                    <td className="tw-w-[5%]">
                      <Skeleton height={25} />
                    </td>
                    <td className="tw-w-[15%]">
                      <Skeleton height={50} width={50} />
                    </td>
                    <td className="tw-w-[50%]">
                      <Skeleton className="tw-flex-1" height={25} />
                    </td>
                    <td className="tw-w-[15%]">
                      <Skeleton height={25} width={60} />
                    </td>
                    <td className="tw-w-fit tw-whitespace-nowrap">
                      <div className="tw-flex tw-justify-end">
                        <Skeleton height={25} width={30} />
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        {/* This empty div creates space for the absolute positioned content */}
        <div className="max-nine:tw-h-[430px] nine:tw-h-[460px]"></div>
      </div>
    </div>
  );
}
